import { ResponseBody } from "../../../../../types/response/response-body.interface";
import { OssStsRes } from "../../../../../types/oss/oss-sts.interface";
import { ApiService } from "@/api";

export const getSts = (
  appId: string
): Promise<ResponseBody<OssStsRes>> => {
  return ApiService.baseAction(`oss/sts/${appId}`, {});
};
